import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Box, Button, TextField, Typography, Alert } from '@mui/material';
import axios from 'axios';

//const API_URL = 'http://localhost:3001/api';
//For Hosting
const API_URL = '/api';

const LoginPage: React.FC = () => {
  const [email, setEmail] = useState('');
  const [apiToken, setApiToken] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  // RC Replace only the handleLogin function
  const handleLogin = async (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    // Validate email format
    if (!email.includes('@')) {
      setError('Please enter a valid email address');
      setLoading(false);
      return;
    }

    // Validate API token
    if (!apiToken.trim()) {
      setError('Please enter your API token');
      setLoading(false);
      return;
    }

    try {
      // Use the new authentication endpoint
      const response = await axios.post(`${API_URL}/auth/login`, {
        email: email.trim(),
        apiToken: apiToken.trim()
      }, { withCredentials: true }); // Important for cookies

      if (response.data.success) {
        // Store only non-sensitive user info if needed
        sessionStorage.setItem('userName', response.data.user);
        navigate('/query');
      }
    } catch (err: any) {
      console.error('Error details:', err.response?.data || err.message);
      
      if (err.response?.data?.error?.message) {
        setError(err.response.data.error.message);
      } else if (err.response?.data?.message) {
        setError(err.response.data.message);
      } else {
        setError('Failed to connect to Jira. Please check your credentials and try again.');
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" minHeight="100vh">
      <Typography variant="h4" mb={2}>Bug Scrubber Login</Typography>
      <Box component="form" onSubmit={handleLogin} width={300}>
        <TextField
          label="Jira Email"
          variant="outlined"
          fullWidth
          margin="normal"
          value={email}
          onChange={e => setEmail(e.target.value)}
          required
          type="email"
          placeholder="your.email@example.com"
          helperText="Enter your Atlassian account email"
        />
        <TextField
          label="Jira API Token"
          type="password"
          variant="outlined"
          fullWidth
          margin="normal"
          value={apiToken}
          onChange={e => setApiToken(e.target.value)}
          required
          placeholder="Enter your Jira API token"
          helperText="Get your API token from https://id.atlassian.com/manage-profile/security/api-tokens"
        />
        {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
        <Button
          type="submit"
          variant="contained"
          color="primary"
          fullWidth
          sx={{ mt: 2 }}
          disabled={loading}
        >
          {loading ? 'Connecting...' : 'Connect to Jira'}
        </Button>
      </Box>
    </Box>
  );
};

export default LoginPage; 